import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=4dcff90c&scoped=true&"
import script from "./ProjectDescription.vue?vue&type=script&lang=js&"
export * from "./ProjectDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDescription.vue?vue&type=style&index=0&id=4dcff90c&lang=stylus&scoped=true&"
import style1 from "./ProjectDescription.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcff90c",
  null
  
)

export default component.exports